import { NgModule } from '@angular/core';
import { ToolbarComponent } from '../core/toolbar/toolbar.component';
import { SideNavBarComponent } from '../core/side-nav-bar/side-nav-bar.component';
import { SharedModule } from '../shared/shared.module';
import { TranslocoModule } from '@ngneat/transloco';
import { FeatureModule } from '../feature/feature.module';
import { ButtonModule } from '../feature/button/button.module';


@NgModule({
  declarations: [
    ToolbarComponent,
    SideNavBarComponent,
  ],
  imports: [
    SharedModule,
    TranslocoModule,
    ButtonModule
  ],
  exports: [
    ToolbarComponent,
    SideNavBarComponent,
    SharedModule
  ]
})
export class CoreModule { }
